import { RankingSelector } from 'feature/ranking/ranking-selector';
import { CHECK_TEXT, CLICK, componentWithVariants, demoFile, POPUP, story, variant } from 'system/demo';
import { t } from 'util/stdtypes';

demoFile('feature/ranking/ranking-selector');

componentWithVariants('RankingSelector', RankingSelector, {}, [
    variant(
        'Two Options',
        {
            config: {
                commentRankers: [
                    { key: 'newest', label: t('Newest'), ranker: () => [] },
                    { key: 'oldest', label: t('Oldest'), ranker: () => [] },
                ],
            },
            args: { testID: 'ranking-select' },
        },
        [story('Select Oldest', [CLICK('ranking-select'), POPUP(CLICK('Oldest')), CHECK_TEXT('Oldest')])],
    ),
    variant('One Option', {
        config: { commentRankers: [{ key: 'newest', label: t('Newest'), ranker: () => [] }] },
        args: { testID: 'single-ranking' },
    }),
]);
